import React from "react";

const Footer = () => {

  const REACT_FRONTEND_URL = process.env.REACT_FRONTEND_URL;
  const FooterLink = [
    {
      Title: "About us",
      Link: `${REACT_FRONTEND_URL}/about-us`,
    },
    {
      Title: "Feedback",
      Link: `${REACT_FRONTEND_URL}/feedback`,
    },
    {
      Title: "Legel",
      Link: `${REACT_FRONTEND_URL}/legal`,
    },
    {
      Title: "Privacy",
      Link: `${REACT_FRONTEND_URL}/privacy`,
    },
  ];

  return (
    <div className="bg-white rounded-none lg:rounded-lg shadow-md hover:shadow-lg p-5 my-5 md:my-0">
      <div className="flex flex-col lg:flex-row justify-start lg:justify-between  gap-5 text-sm md:text-sm">
        <div className="text-[#404040]">
          Admin Administration © MREN Group 2024, Allrights reserved
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 place-items-start lg:place-items-center gap-3">
          {FooterLink?.length > 0 &&
            FooterLink?.map((d, index) => (
              <a
                key={index}
                href={d?.Link}
                target={"_blank"}
                className="w-20 text-[#3B8FD4] text-start lg:text-center"
              >
                {d?.Title}
              </a>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Footer;
